export const messages = {
    "shared-link.footer.link.install": "Vyzkoušejte {brandName} zdarma.",
    "shared-link.footer.link.mobile": "{brandName} pro mobilní zařízení",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Chráněná data",
    "shared-link.password-dialog-box.message": "Zadejte heslo pro přístup ke sdíleným datům.",
    "shared-link.password-dialog-box.hint.password": "Heslo",
    "shared-link.password-dialog-box.message.invalid-password": "Heslo je nesprávné",
    "shared-link.form.button.open": "Otevřít",
    "shared-link.page-not-found.title": "Stránka nebyla nalezena.",
    "shared-link.page-not-found.message.main": "Hledaná stránka nebyla nalezena.",
    "shared-link.page-not-found.message.description": "Odkaz může být zastaralý nebo jste možná zadali nesprávnou adresu.",
    "shared-link.page-not-found.message.error": "Chybový kód: 404",
    "shared-link.restore-file.label.size": "Velikost",
    "shared-link.restore-file.button.restore": "Stáhnout",
    "shared-link.links-table.column.name": "Název",
    "shared-link.links-table.column.size": "Velikost",
    "shared-link.links-table.action.restore": "Stáhnout",
    "shared-link.links-table.action.restore-all": "Stáhnout vše",
    "shared-link.side-bar.selected.title:plural": "Počet vybraných položek: {count} | {count} položka vybrána | Počet vybraných položek: {count} | Počet vybraných položek: {count} | Počet vybraných položek: {count}",
    "shared-link.links-table.label.size": "Velikost",
    "shared-link.links-table.message.empty-folder": "Tato složka je prázdná."
};
